import { Auth } from 'aws-amplify';

/** api3 host — same dev/prod switch as REACT_APP_BACKEND (Amplify branch env). */
function getApi3Base() {
  const backend = (process.env.REACT_APP_BACKEND || 'dev').trim().toLowerCase();
  return `https://api.agorisk.com/${backend}`;
}

function buildUrl(path, query) {
  const base = getApi3Base();
  const url = new URL(`${base}${path.startsWith('/') ? path : `/${path}`}`);
  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url.searchParams.set(key, String(value));
      }
    });
  }
  return url.toString();
}

async function getBearerToken() {
  const session = await Auth.currentSession();
  return session.getAccessToken().getJwtToken();
}

export async function api3Request(path, { method = 'GET', query, body } = {}) {
  const jwt = await getBearerToken();
  const init = {
    method,
    headers: {
      Authorization: `Bearer ${jwt}`,
      Accept: 'application/json',
    },
  };
  if (body !== undefined) {
    init.headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify(body);
  }
  const response = await fetch(buildUrl(path, query), init);
  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = { status: 'error', message: response.statusText || 'Invalid JSON response' };
  }
  if (!response.ok) {
    const message = data?.message || data?.status || `Request failed (${response.status})`;
    const err = new Error(message);
    err.status = response.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function api3Get(path, query) {
  return api3Request(path, { method: 'GET', query });
}

export function api3Post(path, body, query) {
  return api3Request(path, { method: 'POST', body, query });
}

export function api3Put(path, body, query) {
  return api3Request(path, { method: 'PUT', body, query });
}

export function api3Delete(path, query) {
  return api3Request(path, { method: 'DELETE', query });
}
